import { useCallback, useEffect, useState } from "react"
import { canUseDom } from "@design-system/utils"

export interface Dimensions {
  windowWidth: number
  windowHeight: number
  screenWidth: number
  screenHeight: number
}

export function getCurrentDimensions(): Dimensions {
  let windowWidth = -1
  let windowHeight = -1
  let screenWidth = -1
  let screenHeight = -1

  if (canUseDom()) {
    windowWidth = window.innerWidth
    windowHeight = window.innerHeight
    screenWidth = window.screen.width
    screenHeight = window.screen.height
  }

  return {
    windowWidth,
    windowHeight,
    screenWidth,
    screenHeight,
  }
}

export function useDimensions() {
  const [dimensions, setDimensions] = useState(getCurrentDimensions())

  const updateDimensions = useCallback(() => {
    setDimensions(getCurrentDimensions())
  }, [])

  useEffect(() => {
    window.addEventListener("resize", updateDimensions, false)

    return window.removeEventListener("resize", updateDimensions)
  }, [])

  return dimensions
}
